import { FormControlLabel, Checkbox as MUICheckbox } from '@mui/material'
import { ReactNode } from 'react'

export const Checkbox = ({
  label,
  name,
  value,
  checked,
  onChange,
  disabled,
}: {
  label?: string | ReactNode
  name: string
  value?: string
  checked?: boolean
  onChange?: (e: any) => void
  disabled?: boolean
}) => {
  return (
    <FormControlLabel
      control={
        <MUICheckbox
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      }
      label={label}
    />
  )
}
